import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  useAddCouponMutation,
  useCouponsQuery,
  useDeleteCouponMutation,
  useUpdateCouponMutation,
} from "../../service/couponApi";
import Loading from "../../components/Loading/Loading";
import DeleteModal from "../../components/Common/DeleteModal/DeleteModal";

const ManageCoupon = () => {
  const [couponCode, setCouponCode] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [maxUse, setMaxUse] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [addCoupon] = useAddCouponMutation();
  const { data, isLoading } = useCouponsQuery();
  const [selected, setSelected] = useState({});
  const [show, setShow] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteCoupon] = useDeleteCouponMutation();
  const [updateData, setUpdateData] = useState({
    couponCode: "",
    startDate: "",
    endDate: "",
    maxUse: 0,
    discount: 0,
  });
  const [updateCoupon] = useUpdateCouponMutation();

  const handleAddCoupon = () => {
    if (couponCode && startDate && endDate) {
      const data = {
        couponCode,
        startDate,
        endDate,
        maxUse: maxUse ? maxUse : 0,
        discount: discount,
      };
      const startD = new Date(startDate);
      const endD = new Date(endDate);
      if (endD > startD) {
        addCoupon(data).then((res) => {
          if (res?.data?.status) {
            toast.success(res?.data?.message);
            setCouponCode("");
            setStartDate("");
            setEndDate("");
            setMaxUse("");
            setDiscount(0);
          } else {
            toast.error(res?.data?.message);
          }
        });
      } else {
        toast.error("End Date should be greater than Start Date");
      }
    } else {
      toast.error("Please fill all the fields!");
    }
  };

  const handleUpdateCoupon = () => {
    if (
      updateData?.couponCode &&
      updateData?.startDate &&
      updateData?.endDate &&
      updateData?.discount
    ) {
      const startD = new Date(updateData?.startDate);
      const endD = new Date(updateData?.endDate);
      if (endD > startD) {
        updateCoupon({ id: selected?._id, data: updateData }).then((res) => {
          if (res?.data?.status) {
            toast.success(res?.data?.message);
            setSelected({});
            setUpdateData({
              couponCode: "",
              startDate: "",
              endDate: "",
              maxUse: 0,
              discount: 0,
            });
            setShow(false);
          } else {
            toast.error(res?.data?.message);
          }
        });
      } else {
        toast.error("End Date should be greater than Start Date");
      }
    } else {
      toast.error("Please fill all the fields!");
    }
  };

  const handleDeleteCoupon = () => {
    if (selected?._id) {
      deleteCoupon(selected?._id).then((res) => {
        if (res?.data?.status) {
          toast.success(res?.data?.message);

          setShow(false);
          setDeleteModal(false);
          setSelected({});
        } else {
          toast.error(res?.data?.message);
        }
      });
    } else {
      toast.error("Please Select at least one element!");
    }
  };

  if (isLoading) {
    return <Loading></Loading>;
  }

  return (
    <div className="container mx-auto">
      <div className="bg-gray-700 my-[30px] rounded p-[10px]">
        <h3 className="text-start text-[20px] font-bold text-white mb-[20px]">
          Add Coupon
        </h3>
        <div className="mb-[15px] flex flex-col">
          <label className="text-white mb-[10px]">Coupon Code</label>
          <input
            type="text"
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] md:w-[50%] lg:w-[33%] rounded"
          />
        </div>
        <div className="mb-[15px] flex flex-col">
          <label className="text-white mb-[10px]">Discount(%)</label>
          <input
            type="text"
            value={discount}
            onChange={(e) => setDiscount(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] md:w-[50%] lg:w-[33%] rounded"
          />
        </div>
        <div className="mb-[15px] flex flex-col">
          <label className="text-white mb-[10px]">Start Date</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] md:w-[50%] lg:w-[33%] rounded"
          />
        </div>
        <div className="mb-[15px] flex flex-col">
          <label className="text-white mb-[10px]">End Date</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] md:w-[50%] lg:w-[33%] rounded"
          />
        </div>
        <div className="mb-[15px] flex flex-col">
          <label className="text-white mb-[10px]">
            Max Use(If unlimited, then skip the field)
          </label>
          <input
            type="number"
            value={maxUse}
            onChange={(e) => setMaxUse(e.target.value)}
            className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] md:w-[50%] lg:w-[33%] rounded"
          />
        </div>
        <button
          onClick={handleAddCoupon}
          className="bg-[#47db47] px-[20px] py-[7px] rounded text-[white] hover:bg-[#399439] active:bg-[#9b3232]"
        >
          Add Coupon
        </button>
      </div>

      {/* table */}
      <div className="bg-gray-700 my-[30px] rounded p-[10px]">
        <h3 className="text-start text-[20px] font-bold text-white mb-[20px]">
          Coupon List
        </h3>

        <div class="relative overflow-x-auto shadow-md bg-gray-900 sm:rounded-lg">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead>
              <tr className="shadow shadow-gray-700">
                <th scope="col" class="px-6 py-3">
                  Coupon Code
                </th>
                <th scope="col" class="px-6 py-3">
                  Discount(%)
                </th>
                <th scope="col" class="px-6 py-3">
                  Start Date
                </th>
                <th scope="col" class="px-6 py-3">
                  End Date
                </th>
                <th scope="col" class="px-6 py-3">
                  Max Use
                </th>
                <th scope="col" class="px-6 py-3">
                  People Used
                </th>
                <th scope="col" class="px-6 py-3">
                  Update
                </th>
                <th scope="col" class="px-6 py-3">
                  Delete
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.data?.map((d) => (
                <tr className="shadow shadow-gray-700">
                  <td class="px-6 py-4">{d?.couponCode}</td>
                  <td class="px-6 py-4">{d?.discount}%</td>
                  <td class="px-6 py-4">{d?.startDate}</td>
                  <td class="px-6 py-4">{d?.endDate}</td>
                  <td class="px-6 py-4">
                    {d?.maxUse ? d?.maxUse : "Unlimited"}
                  </td>
                  <td class="px-6 py-4">{d?.used}</td>

                  <td class="px-6 py-4">
                    <button
                      onClick={() => {
                        setShow(true);
                        setSelected(d);
                        setUpdateData({
                          couponCode: d?.couponCode,
                          startDate: d?.startDate,
                          endDate: d?.endDate,
                          maxUse: d?.maxUse,
                          discount: d?.discount,
                        });
                      }}
                      className="bg-[#47db47] px-[20px] py-[7px] rounded text-[white] hover:bg-[#399439] active:bg-[#9b3232]"
                    >
                      Update
                    </button>
                  </td>
                  <td class="px-6 py-4">
                    <button
                      onClick={() => {
                        setSelected(d);
                        setDeleteModal(true);
                      }}
                      className="bg-[#ce3737] px-[20px] py-[7px] rounded text-[white] hover:bg-[#ff3939] active:bg-[#9b3232]"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* modal */}

      {show && (
        <div class="fixed top-0 left-0 right-0 bottom-0 z-50 pt-[200px] w-full flex justify-center p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
          <div class="relative w-full max-w-md max-h-full">
            <div class="relative rounded-lg shadow bg-gray-600">
              <button
                onClick={() => setShow(false)}
                type="button"
                class="absolute top-3 right-2.5 text-gray-300 bg-transparent rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center hover:text-white"
                data-modal-hide="authentication-modal"
              >
                <svg
                  class="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span class="sr-only">Close modal</span>
              </button>
              <div class="px-6 py-6 lg:px-8">
                <h3 className="text-start text-[20px] font-bold text-white mb-[20px]">
                  Add Coupon
                </h3>
                <div className="mb-[15px] flex flex-col">
                  <label className="text-white mb-[10px]">Coupon Code</label>
                  <input
                    type="text"
                    value={updateData?.couponCode}
                    name="couponCode"
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        [e.target.name]: e.target.value,
                      })
                    }
                    className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] rounded"
                  />
                </div>
                <div className="mb-[15px] flex flex-col">
                  <label className="text-white mb-[10px]">Discount(%)</label>
                  <input
                    type="text"
                    value={updateData?.discount}
                    name="discount"
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        [e.target.name]: e.target.value,
                      })
                    }
                    className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] rounded"
                  />
                </div>
                <div className="mb-[15px] flex flex-col">
                  <label className="text-white mb-[10px]">Start Date</label>
                  <input
                    type="date"
                    name="startDate"
                    value={updateData?.startDate}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        [e.target.name]: e.target.value,
                      })
                    }
                    className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] rounded"
                  />
                </div>
                <div className="mb-[15px] flex flex-col">
                  <label className="text-white mb-[10px]">End Date</label>
                  <input
                    type="date"
                    value={updateData?.endDate}
                    name="endDate"
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        [e.target.name]: e.target.value,
                      })
                    }
                    className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] rounded"
                  />
                </div>
                <div className="mb-[15px] flex flex-col">
                  <label className="text-white mb-[10px]">
                    Max Use(If unlimited, then skip the field)
                  </label>
                  <input
                    type="number"
                    name="maxUse"
                    value={updateData?.maxUse}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        [e.target.name]: e.target.value,
                      })
                    }
                    className="bg-gray-900 outline-none font-[17px] text-white p-[10px] w-[100%] rounded"
                  />
                </div>
                <button
                  onClick={handleUpdateCoupon}
                  className="bg-[#47db47] w-[100%] px-[20px] py-[7px] rounded text-[white] hover:bg-[#399439] active:bg-[#9b3232]"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {deleteModal && (
        <DeleteModal
          handleDelete={handleDeleteCoupon}
          closeModal={setDeleteModal}
        />
      )}
    </div>
  );
};

export default ManageCoupon;
